import { combineReducers } from "redux";
import allUserInfoReducer from "./all-user-info";
import adminReducer from "./admin";
import dispatchEventFeedReducer from "./dispatch-event-feed";
import eventManagementReducer from "./event-management";
import mapReducer from "./map";
import geoJsonReducer from "./geo-json";
import userInfoReducer from "./user-info";
import vccIncidentReducer from "./vcc-incident";

export * from "./interfaces";
export * from "./states/dispatch-event-feed-state";
export * from "./states/admin";

export type IDispatchEventFeedReducer = ReturnType<
  typeof dispatchEventFeedReducer
>;
export type IVccIncidentReducer = ReturnType<typeof vccIncidentReducer>;
export type IRootReducer = ReturnType<typeof rootReducer>;

export const rootReducer = combineReducers({
  adminReducer: adminReducer,
  allUserInfoReducer: allUserInfoReducer,
  dispatchEventFeedReducer: dispatchEventFeedReducer,
  eventManagementReducer: eventManagementReducer,
  geoJsonReducer: geoJsonReducer,
  mapReducer: mapReducer,
  userInfoReducer: userInfoReducer,
  vccIncidentReducer: vccIncidentReducer,
});
